import { IStyle, classNamesFunction } from '@fluentui/react';

export interface ISignUpBrandedHeaderStyles {
    containerFluid: IStyle;
    row: IStyle;
    colLgThree: IStyle;
    colLgSeven: IStyle;
    colXsTwelve: IStyle;
    colLgTen: IStyle;
    signUpHeader: IStyle;
    bodyCopySmall: IStyle;
    colXsZero: IStyle;
}

export const getSignUpHeaderStyles = (): ISignUpBrandedHeaderStyles => {
    return {
        containerFluid: {
            paddingRight: '15px',
            paddingLeft: '15px',
            marginRight: 'auto',
            marginLeft: 'auto',
        },
        row: {
            padding: '0',
            margin: '0',
        },
        colLgThree: {
            position: 'relative',
            minHeight: '1px',
            padding: '0',
            marginLeft: '0',
            marginRight: '0',
            alignItems: 'stretch',
            float: 'left',
            selectors: {
                '@media(min-width: 1200px)': {
                    width: '25%',
                },
            },
        },
        colLgSeven: {
            padding: '0',
            marginLeft: '0',
            marginRight: '0',
            position: 'relative',
            minHeight: '1px',
            selectors: {
                '@media(min-width: 1200px)': {
                    width: '58.33333333%',
                },
            },
        },
        colXsTwelve: {
            padding: '0',
            marginLeft: '0',
            marginRight: '0',
            float: 'left',
            position: 'relative',
            minHeight: '1px',
            alignItems: 'stretch',
            margin: '0',
            width: '100%',
        },
        colXsZero: {
            alignItems: 'stretch',
            float: 'left',
            width: '100%',
            position: 'relative',
            margin: '0',
            padding: '1em 1em',
        },
        colLgTen: {
            marginTop: '0',
            marginBottom: '0',
            padding: '0',
            marginLeft: '0',
            marginRight: '0',
            position: 'relative',
            minHeight: '1px',
            alignItems: 'stretch',
            float: 'left',
            selectors: {
                '@media(min-width: 1200px)': {
                    width: '83.33333333%',
                },
            },
        },
        signUpHeader: {
            marginBottom: '20px',
            fontSize: '40px',
        },
        bodyCopySmall: {
            fontFamily: "'Segoe UI', 'Segoe UI Web', 'wf_segoe-ui_normal', 'Helvetica Neue', 'BBAlpha Sans', 'S60 Sans', Arial, sans-serif",
            color: '#1e1e1e',
            fontSize: '14px',
            lineHeight: '1.5',
            marginBottom: '3px',
        },
    };
};

export const getSignUpHeaderClassNames = classNamesFunction<{}, ISignUpBrandedHeaderStyles>();
